import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useGetGroupsQuery } from '@/api/v1';
import { GroupListItem } from '@/components/molecules/GroupListItem';
import { ApplicationModal } from '@/components/organisms/ApplicationModal';
import type { Group } from '@/DTOs/groups';
import { useTranslator } from '@/hooks/useTranslator';

export const ManageRolesModal: React.FC = (): React.ReactElement => {
  const [expandedGroupId, setExpandedGroupId] = React.useState<string | false>(false);

  const tr = useTranslator();
  const navigate = useNavigate();

  const { data: groups = [] } = useGetGroupsQuery();
  const { groupId: editingGroupId = false } = useParams();

  const onAddNew = React.useCallback((): void => {
    navigate('new');
  }, [navigate]);

  const onClose = React.useCallback((): void => {
    navigate('/settings/users');
  }, [navigate]);

  return (
    <ApplicationModal title={tr('MANAGE_ROLES')} variant="prominent" onClose={onClose}>
      <List>
        {groups.map(
          (group: Group): React.ReactElement => (
            <GroupListItem
              key={group.groupId}
              expandedGroupId={expandedGroupId}
              editingGroupId={editingGroupId}
              group={group}
              onExpand={setExpandedGroupId}
            />
          ),
        )}
      </List>
      <Box mt={4}>
        <Button variant="contained" fullWidth={true} onClick={onAddNew}>
          {tr('ADD_NEW')}
        </Button>
      </Box>
    </ApplicationModal>
  );
};
